import React from 'react';
import { Link } from 'react-router-dom';
import { usePerfil } from '../context/PerfilContext';
import { CuentaPendiente } from '../pages/CuentaPendiente';
import { Lock, ArrowLeft } from 'lucide-react';

/**
 * Guardas de permisos para las rutas privadas.
 *
 * Esto evita que alguien entre escribiendo la URL a mano, pero no es la
 * seguridad de verdad: cualquiera puede manipular el JavaScript del navegador.
 * Quien impide leer o escribir datos sin permiso son las reglas de Firestore.
 */

const Cargando: React.FC = () => (
  <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
    <div className="text-gray-500 dark:text-gray-400">Cargando…</div>
  </div>
);

const SinAcceso: React.FC<{ titulo: string; texto: string }> = ({ titulo, texto }) => (
  <div className="max-w-md mx-auto px-4 py-16 text-center">
    <div className="w-14 h-14 mx-auto rounded-full bg-gray-100 dark:bg-gray-700 flex items-center justify-center mb-4">
      <Lock className="w-6 h-6 text-gray-400" />
    </div>
    <h1 className="text-lg font-bold text-gray-900 dark:text-white">{titulo}</h1>
    <p className="text-sm text-gray-600 dark:text-gray-400 mt-1.5">{texto}</p>
    <Link to="/"
      className="inline-flex items-center gap-1.5 mt-5 px-4 py-2 rounded-lg text-sm font-semibold
                 border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300
                 hover:bg-gray-50 dark:hover:bg-gray-700 transition">
      <ArrowLeft className="w-4 h-4" /> Volver al inicio
    </Link>
  </div>
);

/** Cualquier página privada: exige tener al menos un módulo activado. */
export const ConCuentaActiva: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { cargandoPerfil, tieneAlgunModulo } = usePerfil();
  if (cargandoPerfil) return <Cargando />;
  if (!tieneAlgunModulo) return <CuentaPendiente />;
  return <>{children}</>;
};

/** Página de un módulo concreto. */
export const ConModulo: React.FC<{ modulo: string; children: React.ReactNode }> =
  ({ modulo, children }) => {
    const { cargandoPerfil, tieneModulo, tieneAlgunModulo } = usePerfil();
    if (cargandoPerfil) return <Cargando />;
    if (!tieneAlgunModulo) return <CuentaPendiente />;
    if (!tieneModulo(modulo)) {
      return (
        <SinAcceso
          titulo="Este módulo no está activado en tu cuenta"
          texto="Si crees que deberías tener acceso, pídeselo a un administrador."
        />
      );
    }
    return <>{children}</>;
  };
